import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

export const IdeaCard_Idea = graphql(/* GraphQL */ `
  fragment IdeaCard_Idea on Idea @_unmask {
    id
    content {
      title
      text
      aiAssisted
      date
      services
      media {
        id
        url
        alt
        thumbnailUrl
        type
        size
        source {
          name
          id
          author
        }
      }
      tags {
        id
        name
        color
      }
    }
    organizationId
    groupId
    position
    createdAt
    updatedAt
  }
`)

export type IdeaCardIdea = ResultOf<typeof IdeaCard_Idea>
